import script from "./index.vue?vue&type=script&lang=ts&setup=true"
export * from "./index.vue?vue&type=script&lang=ts&setup=true"

import "./index.vue?vue&type=style&index=0&id=243d1352&scoped=true&lang=less"
import "./index.vue?vue&type=style&index=1&id=243d1352&lang=less"

import exportComponent from "D:\\work\\risfond-branchmanagementsystem\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-243d1352"]])

export default __exports__